import { Form, Field } from './Form';
import Input from './Input';
import Select from './Select';
import HiddenField from './HiddenField';
import { validators } from './validator';

/**
 * Note, expensive compoents such as InternationalPhoneInput are not included
 * so that we don't blow out bundle sizes when using basic inputs. You will need to import
 * them directly.
 */

const ChowbusForm = {
  Form,
  Field,
  HiddenField,
  Input,
  Select,
  validators,
};

export default ChowbusForm;
